
import {Vue, Component, Prop} from "vue-property-decorator";

@Component
export default class ProgressIndicator extends Vue{
  @Prop() progress: number;

  mounted() {
    document.documentElement.style.setProperty('--progress', `${this.progress}%`)
  }
}
